import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VibrantFinishesForNorthQueenslandLiving from "./sections/VibrantFinishesForNorthQueenslandLiving";
import QualityAssurance from "./sections/QualityAssurance";
import ThePrepWorkProtocol from "./sections/ThePrepWorkProtocol";
import PropertySpecializations from "./sections/PropertySpecializations";
import TheAnvStandard from "./sections/TheAnvStandard";
import LocalSuccessStories from "./sections/LocalSuccessStories";
import ReadyToRefreshYourProperty from "./sections/ReadyToRefreshYourProperty";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VibrantFinishesForNorthQueenslandLiving />
      <QualityAssurance />
      <ThePrepWorkProtocol />
      <PropertySpecializations />
      <TheAnvStandard />
      <LocalSuccessStories />
      <ReadyToRefreshYourProperty />
      <Footer />
    </div>;
}